module.exports = __webpack_public_path__ + "static/media/CompanyProfilebg.741a4ead.png";